import { NotificationDataTable } from "@/features/notifications/components";
import { useNotificationTableLogic } from "@/features/notifications/managers";
export const CustomerNotification: React.FC<{customerID: string}> = ({
  customerID
}) => {
  const {
    users,
    loading,
    pagination,
    currentFilters,
    onPageChange,
    onPageSizeChange,
    onSortChange,
    onFilterChange,
    onView,
  } = useNotificationTableLogic(customerID);
  return (
    <NotificationDataTable
      users={users}
      onClickNotification={onView}
      loading={loading}
      pagination={pagination}
      currentFilters={currentFilters}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSortChange={onSortChange}
      onFilterChange={onFilterChange}
      onView={onView}
    />
  )
}